

export class TyreStatusOutput implements ITyreStatusOutput {
    status!: number;
    message!: string;

    constructor(data?: ITyreStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): TyreStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface ITyreStatusOutput {
    status: number;
    message: string;
}

